export default __webpack_public_path__ + "static/media/icon-green-tick.2ec62ef6.svg";